import { useEffect, useState } from 'react';

export default function useMobileKeyboardOpen(active) {
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    if (!active) {
      setKeyboardOpen(false);
      return undefined;
    }

    const viewport = window.visualViewport;
    const viewportHeight = () => viewport?.height || window.innerHeight;
    const isEditing = () => Boolean(document.activeElement?.closest?.('input, textarea, [contenteditable="true"], [role="textbox"]'));
    let fullHeight = viewportHeight();
    let sawKeyboardResize = false;
    let dismissedWhileFocused = false;
    const onFocus = () => {
      dismissedWhileFocused = false;
      setKeyboardOpen(isEditing());
    };
    const onBlur = () => setKeyboardOpen(false);
    const onResize = () => {
      const height = viewportHeight();
      if (!isEditing()) {
        fullHeight = Math.max(fullHeight, height);
        sawKeyboardResize = false;
        dismissedWhileFocused = false;
        setKeyboardOpen(false);
        return;
      }
      if (fullHeight - height > 120) {
        sawKeyboardResize = true;
        dismissedWhileFocused = false;
        setKeyboardOpen(true);
      } else if (sawKeyboardResize) {
        dismissedWhileFocused = true;
        sawKeyboardResize = false;
        setKeyboardOpen(false);
      } else if (!dismissedWhileFocused) {
        setKeyboardOpen(true);
      }
    };

    viewport?.addEventListener('resize', onResize);
    window.addEventListener('resize', onResize);
    document.addEventListener('focusin', onFocus);
    document.addEventListener('focusout', onBlur);
    onFocus();
    return () => {
      viewport?.removeEventListener('resize', onResize);
      window.removeEventListener('resize', onResize);
      document.removeEventListener('focusin', onFocus);
      document.removeEventListener('focusout', onBlur);
    };
  }, [active]);

  return keyboardOpen;
}
